export default {
  roundtrip: {
    roundtripOptions: 'Opções de rota circular'
  }
}
